module.exports = __webpack_public_path__ + "img/icon-about-kik.98f49e48.svg";